<script>
  import { writable } from "svelte/store";
  import { format } from "date-fns";
  import { pmfilters } from "lib/stores.js";
  import { isValidRegex } from "../../../../../../lib/util/regex";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { Modal } from "carbon-components-svelte";
  import { TextInput } from "paxray-components-svelte";
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import ProcessFlowFilter from "./ProcessFlowFilter.svelte";
  import ValueType from "./ValueType.svelte";

  export let modalOpen = false;
  export let filterid = -1;
  export let analysisid;
  export let filterLength = 0;
  export let isLoadingFilter = writable(false);
  export let setHistoryFilter = () => {};

  const { getFilterByCurrentView } = filtersConfigStore;

  let firstTimeOpen = true;
  let processSteps = [];
  let defaultName = "";
  let dateTimeIntervalStructure = {
    startDate: format(new Date(), "dd/MM/yyyy"),
    endDate: format(new Date(), "dd/MM/yyyy"),
    startDataTime: "00:00",
    endDataTime: "00:00",
    startTime: "00:00",
    endTime: "00:00",
  };
  let dateTimeStructure = {
    date: format(new Date(), "dd/MM/yyyy"),
    time: "00:00",
  };
  let timeStructure = {
    hours: NaN,
    mins: NaN,
    secs: NaN,
  };

  let filterCreate = {
    name: "",
    type: "",
    col: "",
    value: [],
    comparison: "eq",
    datatype: "",
    steps: [],
    title: "",
  };
  let selectedIndex = 0;
  let newfilterstep = "";
  let options = [];

  let selectedIds = [];
  let filters = null;
  let nameFromFilter = "";
  let disableContentSwitcher = [];

  $: ({
    currentView,
    processFlowSteps,
    filterOperators,
    filterColumnDefinitions,
    filterDefinitions,
    filterAllowedOperators,
    tab,
    storeLoaded,
    views,
  } = $filtersConfigStore);

  let filtersByView = [];
  $: {
    if (storeLoaded) {
      filtersByView = getFilterByCurrentView(
        views,
        filterDefinitions,
        filterColumnDefinitions,
        filterAllowedOperators,
        filterOperators,
        currentView,
        tab
      );
    }
  }

  $: processSteps = processFlowSteps;
  $: {
    if (currentView) {
      filters = filtersByView;
      if (filters && filters.length > 0) {
        options = [...filters.map((filter) => filter.title)];
      }
    }
  }

  $: if (modalOpen && firstTimeOpen) {
    if (filterLength === 0 && $pmfilters[analysisid].length - 1 >= filterid) {
      filterCreate = { ...$pmfilters[analysisid][filterid] };
    }
    firstTimeOpen = false;
  }

  let lastView;
  $: {
    if (currentView && currentView !== lastView) {
      selectedIndex = 0;
      lastView = currentView;
    }
  }

  $: {
    setNameAndType(filters, selectedIndex);
  }

  $: {
    loadFilter(filterid);
  }

  $: {
    if (newfilterstep != "") {
      filterCreate.steps.push(newfilterstep);
      filterCreate.value = filterCreate.steps;
      filterCreate = filterCreate;
      newfilterstep = "";
    }
  }

  $: {
    if (selectedIds.length > 0 && filterCreate.col == "team") {
      filterCreate.value = selectedIds;
    }
  }

  $: isInvalidRegex =
    filterCreate.comparison === "regex"
      ? !isValidRegex(filterCreate.value)
      : false;

  $: isDisabledSubmit = disableSubmit(filterCreate);

  function setNameAndType(filters, selectedIndex) {
    if (
      filters &&
      filters.length > 0 &&
      selectedIndex >= 0 &&
      (filterid === filterLength || filterLength == 0)
    ) {
      filterCreate.type = filters[selectedIndex].type;
      filterCreate.name = filters[selectedIndex].title;
      filterCreate.title = filters[selectedIndex].title;
    }
  }

  async function loadFilter(filterid) {
    selectedIndex = -1;
    if (filterid === filterLength) {
      selectedIndex = 0;
      setNameAndType(filters, selectedIndex);
      return;
    }
    if (filterid != -1 && $pmfilters[analysisid].length - 1 >= filterid) {
      isLoadingFilter.set(true);
      setTimeout(() => {
        const filterFromStore = $pmfilters[analysisid][filterid];
        filterCreate = JSON.parse(JSON.stringify(filterFromStore));
        const filters = filtersByView;
        if (Array.isArray(filterCreate.col)) {
          Object.entries(filterColumnDefinitions).forEach(([key, value]) => {
            const valueColumns = value.columns;
            const dataType = value.datatype;
            if (
              valueColumns &&
              Array.isArray(valueColumns) &&
              valueColumns.every((val) => filterCreate.col.includes(val)) &&
              dataType === filterCreate.datatype
            ) {
              filterCreate.col = key;
            }
          });
        } else if (!filterColumnDefinitions[filterCreate.col]) {
          Object.entries(filterColumnDefinitions).forEach(([key, value]) => {
            if (
              value.datatype === filterCreate.datatype &&
              value.columns === filterCreate.col
            ) {
              filterCreate.col = key;
            }
          });
        }
        defaultName = filterCreate.name;
        if (filterCreate.type !== "flow")
          nameFromFilter = getName(filterCreate);
        selectedIndex = filters.findIndex(
          (filter) => filter.title === filterCreate.title
        );
        disableContentSwitcher = options.map((option, index) => index);
        if (
          filterCreate.datatype === "datetimeInterval" ||
          filterCreate.datatype === "timeInterval" ||
          filterCreate.datatype === "dateInterval"
        ) {
          setDateTimeIntervalStructure(filterCreate);
        } else if (
          filterCreate.datatype === "datetime" ||
          filterCreate.datatype === "date" ||
          filterCreate.datatype === "time"
        ) {
          setDateTimeStructure(filterCreate);
        }
        if (filterCreate.datatype === "duration") {
          setTimeStructure(filterCreate.value);
        }
        if (selectedIndex === -1) selectedIndex = 0;
        setTimeout(() => {
          isLoadingFilter.set(false);
        }, 5);
      }, 0);
    }
  }

  function setDateTimeIntervalStructure(filter) {
    if (filter.datatype === "datetimeInterval") {
      const startDate = filter.value[0]
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
      const endDate = filter.value[1]
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
      const startTime = filter.value[0].split("T")[1];
      const endTime = filter.value[1].split("T")[1];
      dateTimeIntervalStructure = {
        startDate: startDate,
        endDate: endDate,
        startDataTime: startTime,
        endDataTime: endTime,
        startTime: startTime,
        endTime: endTime,
      };
    } else if (filter.datatype === "timeInterval") {
      const startTime = filter.value[0];
      const endTime = filter.value[1];
      dateTimeIntervalStructure = {
        ...dateTimeIntervalStructure,
        startDataTime: startTime,
        endDataTime: endTime,
        startTime: startTime,
        endTime: endTime,
      };
    } else if (filter.datatype === "dateInterval") {
      const startDate = filter.value[0]
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
      const endDate = filter.value[1]
        .split("T")[0]
        .split("-")
        .reverse()
        .join("/");
      dateTimeIntervalStructure = {
        ...dateTimeIntervalStructure,
        startDate: startDate,
        endDate: endDate,
      };
    }
  }

  function setDateTimeStructure(filter) {
    if (filter.datatype === "datetime") {
      const [date, time] = filter.value.split("T");
      const startDate = date.split("-").reverse().join("/");
      dateTimeStructure = {
        date: startDate,
        time: time,
      };
    } else if (filter.datatype === "date") {
      const startDate = filter.value.split("-").reverse().join("/");
      dateTimeStructure = {
        ...dateTimeStructure,
        date: startDate,
      };
    } else if (filter.datatype === "time") {
      const startTime = filter.value;
      dateTimeStructure = {
        ...dateTimeStructure,
        time: startTime,
      };
    }
  }

  function setTimeStructure(value) {
    const hours = Math.floor(value / 3600);
    const mins = Math.floor((value % 3600) / 60);
    const secs = value % 60;
    timeStructure = {
      hours: hours,
      mins: mins,
      secs: secs,
    };
  }

  function disableSubmit(filterCreate) {
    const isProcessFlow = options[selectedIndex] == "Process Flow";
    if (isProcessFlow && filterCreate.type == "flow") {
      return filterCreate.steps.length == 0;
    } else if (
      filterCreate.datatype === "timeInterval" ||
      filterCreate.datatype === "dateInterval" ||
      filterCreate.datatype === "datetimeInterval"
    ) {
      return (
        !filterCreate.col ||
        !filterCreate.value ||
        filterCreate.value.length == 0
      );
    } else if (
      filterCreate.datatype === "datetime" ||
      filterCreate.datatype === "date" ||
      filterCreate.datatype === "time"
    ) {
      return (
        !filterCreate.col ||
        !filterCreate.comparison ||
        !filterCreate.value ||
        filterCreate.value.length == 0
      );
    } else if (
      filterCreate.datatype === "number" ||
      filterCreate.datatype === "duration"
    ) {
      return (
        !filterCreate.col ||
        !filterCreate.comparison ||
        (!filterCreate.value && filterCreate.value !== 0) ||
        filterCreate.value < 0 ||
        filterCreate.value.length == 0
      );
    } else {
      return (
        !filterCreate.col ||
        !filterCreate.comparison ||
        !filterCreate.value ||
        filterCreate.value.length == 0 ||
        isInvalidRegex
      );
    }
  }

  function saveFilter() {
    let filterToSave = null;
    if (filterCreate.type == "flow") {
      /// {"name": "Unnamed Flow Filter", "type": "flow", "steps": ["Open MS Navision", "Open Inbox"], "invert": True}
      filterToSave = {
        name: defaultName || filterCreate.title,
        type: filterCreate.type,
        steps: filterCreate.steps,
        invert: filterCreate.invert,
        title: filterCreate.title,
      };
    } else {
      ///{"name": "Activity Selection", "type": "value", "col": "activity", "value": "Confirmation E-Mail", "comparison": "eq", "datatype": "string"}
      filterToSave = {
        name: setName(filterCreate),
        type: filterCreate.type,
        col: setColumn(filterCreate),
        value: filterCreate.value,
        comparison: filterCreate.comparison,
        datatype: filterCreate.datatype,
        title: filterCreate.title,
      };
    }
    $pmfilters[analysisid][filterid] = filterToSave;
    $pmfilters = $pmfilters;
    setHistoryFilter(filterToSave);
    if (filterid == -1) {
      filterCreate = { type: "", name: "", value: "", steps: [], col: "" };
    }
    filterid = -1;
    defaultName = "";
    disableContentSwitcher = [];
  }

  function getName(filter) {
    const col =
      filterColumnDefinitions[filter.col]?.title ||
      Object.values(filterColumnDefinitions).find((col) => {
        return (
          col.columns &&
          col.columns.includes(filter.col) &&
          filter.datatype === col.datatype
        );
      });
    const comparison = filterOperators[filter.comparison].title;
    if (
      filter.datatype === "datetimeInterval" ||
      filter.datatype === "dateInterval" ||
      filter.datatype === "timeInterval"
    ) {
      const startDate = filter.value[0].split("T").join(" ");
      const [dateStart, timeStart] = filter.value[0].split("T");
      const endDate = filter.value[1].split("T").join(" ");
      const [dateEnd, timeEnd] = filter.value[1].split("T");
      if (timeStart === "00:00" && timeEnd === "00:00") {
        return `${col} ${comparison} ${dateStart} and ${dateEnd}`;
      }
      const title =
        filter.datatype === "datetimeInterval" ||
        filter.datatype === "dateInterval"
          ? "Date"
          : "Time";
      return `${title} ${comparison} ${startDate} and ${endDate}`;
    }
    const colDef = filterColumnDefinitions[filter.col];
    if (colDef.valuesWithID) {
      const titleValues = colDef.values
        .filter((value) => {
          return filter.value.includes(value.id);
        })
        .map((value) => value.title);
      return `${col} ${comparison} "${titleValues.join(", ")}"`;
    }
    if (
      filter.datatype === "number" ||
      filter.datatype === "date" ||
      filter.datatype === "time"
    ) {
      return `${col} ${comparison} ${filter.value}`;
    }
    if (filter.datatype === "datetime") {
      const startDate = filter.value.split("T").join(" ");
      const [date, time] = filter.value.split("T");
      if (time === "00:00") {
        return `${col} ${comparison} ${date}`;
      }
      return `${col} ${comparison} ${startDate}`;
    }
    if (filter.datatype === "duration") {
      const hours = Math.floor(filter.value / 3600);
      const mins = Math.floor((filter.value % 3600) / 60);
      const secs = filter.value % 60;
      // Armar el resultado, omitiendo las partes que son 0
      let result = "";

      if (hours > 0) {
        result += `${hours}h `;
      }
      if (mins > 0) {
        // Mostrar minutos solo si hay horas o minutos
        result += `${mins}min `;
      }
      if (secs > 0) {
        // Mostrar segundos solo si son mayores que 0 o si todo es 0
        result += `${secs}s`;
      }

      // Si el resultado está vacío (todos son cero), mostrar 0s
      if (result === "") {
        result = "0s";
      }

      return `${col} ${comparison} ${result}`;
      // return `${col} ${comparison} ${hours}h ${mins}min ${secs}s`;
    }
    return `${col} ${comparison} "${filter.value}"`;
  }

  function setName(filter) {
    const newName = getName(filter);
    if (
      defaultName !== "" &&
      defaultName !== newName &&
      nameFromFilter !== defaultName
    ) {
      return defaultName;
    }
    return newName;
  }

  function setColumn(filter) {
    if (!filter.comparison) {
      const col = filterColumnDefinitions[filter.col];
      return col.columns;
    }
    if (filter.comparison && filterColumnDefinitions[filter.col]?.columns)
      return filterColumnDefinitions[filter.col].columns;
    return filter.col;
  }

  function handleClose() {
    modalOpen = false;
    firstTimeOpen = true;
    filterCreate = { type: "", name: "", value: "", steps: [], col: "" };
    filterid = -1;
    selectedIndex = 0;
    defaultName = "";
    disableContentSwitcher = [];
    dateTimeIntervalStructure = {
      startDate: format(new Date(), "dd/MM/yyyy"),
      endDate: format(new Date(), "dd/MM/yyyy"),
      startDataTime: "00:00",
      endDataTime: "00:00",
      startTime: "00:00",
      endTime: "00:00",
    };
    dateTimeStructure = {
      date: format(new Date(), "dd/MM/yyyy"),
      time: "00:00",
    };
    timeStructure = {
      hours: NaN,
      mins: NaN,
      secs: NaN,
    };
  }
</script>

<Modal
  class="filter-modal"
  modalHeading="Filter"
  preventCloseOnClickOutside
  size="lg"
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  open={modalOpen}
  primaryButtonDisabled={isDisabledSubmit}
  on:submit={() => {
    saveFilter();
    firstTimeOpen = true;
    modalOpen = false;
    filterid = -1;
    selectedIndex = 0;
  }}
  on:close={handleClose}
  on:click:button--secondary={handleClose}
>
  <div class="wrapper">
    <ContentSwitcher
      {options}
      bind:selected={selectedIndex}
      disabled={disableContentSwitcher}
    />
    <TextInput
      bind:value={defaultName}
      labelText="Define Filter Name (optional)"
      placeholder="Filter Name"
    />
    <div class="container">
      {#if options[selectedIndex] == "Process Flow"}
        <ProcessFlowFilter
          bind:filterCreate
          {processSteps}
          bind:newfilterstep
        />
      {:else}
        {#key selectedIndex}
          <ValueType
            bind:filterCreate
            titleTab={options[selectedIndex]}
            bind:isLoadingFilter
            {dateTimeIntervalStructure}
            {dateTimeStructure}
            {timeStructure}
          />
        {/key}
      {/if}
    </div>
  </div>
</Modal>

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  :global(.filter-modal .bx--modal-content) {
    overflow-y: visible !important;
  }
</style>
